<template>
  <div :class="{ 'invalid': !isValid, 'valid': isValid}">
    <div v-if="!isValid" class="error">{{ errorDescription }}</div>
    <div class="dynamic-inputs">
      <div class="value-list" ref="scrollable">
        <div 
          class="value-group group-w-button"
          v-for="(val, index) in newValues" 
          :key="index"
        >
          <BaseIcon
            :name="getIcon(val.valtype)"
            class="icon icon-value"
            @click.native="changeValueType(index)"
          />
          <input
            autocomplete="off"
            type="text"
            :name="`newValues[${index}][name]`"
            v-model="val.name"
            placeholder="Search"
            @input="updateValues(index)"
          />
          <input
            v-if="optionDefault"
            autocomplete="off"
            type="text"
            :name="`newValues[${index}][default]`"
            placeholder="Default"
            @input="updateValues(index)"
            v-model="val.default"
          />
          <input
            autocomplete="off"
            type="text"
            :name="`newValues[${index}][id]`"
            v-model="val.id"
            style="display:none;"
          />
          <BaseIcon
            name="times-circle"
            class="icon ico-delete"
            :class="{ 'delete-disabled': newValues.length == 1 }"
            @click.native="removeValue(index)"
          />
        </div>
        <div class="add-step-button" @click="addNewValue">
          <BaseIcon name="plus-circle" class="icon" />
          <label>Add custom value</label>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseIcon from "@/components/base/Icon";
  import InputDash from "@/components/base/InputDash";
  import VerticalStepBullets from "@/components/base/VerticalStepBullets";
  import AutocompleteList from "@/components/base/AutocompleteList";
  import draggable from 'vuedraggable'

  export default {
    components: {
      BaseIcon, 
      InputDash,
      draggable,
      VerticalStepBullets,
      AutocompleteList
    },
    props: {
      label: String,
      name: String,
      value: String,
      filledValues: Array,
      isTextArea: Boolean,
      isDisabled: Boolean,
      placeholder: String,
      optionDefault: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        stepsResult:[],
        newValues: [],
        isValid: true,
        errorDescription: 'Test can not be empty',
        named_icons: {
          Text: { prefix: "fa", name: "font" },
          Date: { prefix: "far", name: "calendar-alt" },
          Checkbox: { prefix: "fa", name: "check-square" },
          Number: { prefix: "fa", name: "hashtag" }
        },
        possible_icons: [
          { icon: "Text", prefix: "fa", name: "font" },
          { icon: "Date", prefix: "far", name: "calendar-alt" },
          { icon: "Checkbox", prefix: "fa", name: "check-square" },
          { icon: "Number", prefix: "fa", name: "hashtag" }
        ]
      }
    }, 
    mounted() {
      if(this.filledValues.length == 0 || this.filledValues == undefined) {
        this.newValues = [
          {
            id: '',
            name: '',
            valtype: 'Text'
          },
          {
            id: '',
            name: '',
            valtype: 'Text'
          },          
          {
            id: '',
            name: '',
            valtype: 'Text'
          }
        ]
      } else {
        this.newValues = this.filledValues
      }
    },
    methods: {
      addNewValue() {
        this.newValues.push({
            id: "",
            name: "",
            valtype: "Text",
            default: null,
          })
      },
      scrollToEnd() {
        var container = this.$refs.scrollable
        container.scrollTop = container.scrollHeight + 84;
      },
      changeValueType(index) {
        var pos = this.possible_icons.findIndex(i => i.icon === this.newValues[index].valtype);
        pos += 1
        if(pos == 4) {
          pos = 0
        }
        this.newValues[index].valtype = this.possible_icons[pos].icon
      },
      getIcon(icon) {
        return [this.named_icons[icon].prefix, this.named_icons[icon].name];
      },
      updateValues(index) {
        this.$emit('updateValues', this.newValues)
        this.scrollToEnd()
      },
      removeValue(index) {
        if (this.newValues.length > 1) {
          this.newValues.splice(index, 1);
        }
      },
      sumbitForm() {
        const data = {
          newValues: this.newValues
        }
        alert(JSON.stringify(data, null, 2))
      }
    },
  }
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/inputs";
@import "@/style/components/dynamicStepsList";

::placeholder{
  color: #cccccc;
}

.sub-title {
  display: block;
  font-weight: 600;
  color: #035362;
  margin-bottom: 6px;
}

input[type="text"] + input[type="text"] {
  margin-left: 10px;
  margin-right: 40px;
}
</style>
